export const GUMDROP_FIRE_WAVING = "GUMDROP_FIRE_WAVING";
export const GUMDROP_WRITING = "GUMDROP_WRITING";
export const PAGE_FLIP = "PAGE_FLIP";
export const SWIPE_RIGHT = "SWIPE_RIGHT";
